import { BusinessResult, BusinessResultType, BusinessValidationType, BusinessValidation } from '../models/policy-business.model';
import { CountrySpec, countrySpecs } from '../models/iban-country-specification';

export function isValidIBAN(ibanInput: string): BusinessResult {
  
  const iban = ibanInput.toUpperCase();
  const spec = countrySpecs[iban.slice(0, 2)];

  const validationInProgress: BusinessValidation = {
    businessValidationType: BusinessValidationType.ibanSvs,
    errorMessage: '',
    hasError: false,
  };
  const result: BusinessResult = {
    resultType: BusinessResultType.ok,
    messages: [],
    data: null,
    validations: [validationInProgress],
  };

  if (iban == '') {
    result.resultType = BusinessResultType.error;
      result.messages.push('validation.iban.notValid');
      const validationError = { businessValidationType: BusinessValidationType.ibanSvs, errorMessage: 'validation.iban.notValid', hasError: true} as BusinessValidation;
      result.validations.push(validationError);
      return result;
  } else {
    if (spec && spec.IBANRegistry) {
      if (spec.chars !== iban.length) {
        result.resultType = BusinessResultType.error;
        result.messages.push('validation.iban.lengthError');
        const validationError = { businessValidationType: BusinessValidationType.ibanSvs, errorMessage: 'validation.iban.lengthError', hasError: true} as BusinessValidation;
        result.validations.push(validationError);
        return result;
      }
      if (mod9710(prepareIbanForModule97(iban)) !== 1
        || !checkFormatBBAN(iban.slice(4), spec)
        || (iban.slice(0, 2) === 'BE' && isValidBBAN(iban.slice(4)).resultType !== BusinessResultType.ok)) {
        result.resultType = BusinessResultType.error;
        result.messages.push('validation.iban.notValid');
        const validationError = { businessValidationType: BusinessValidationType.ibanSvs, errorMessage: 'validation.iban.notValid', hasError: true} as BusinessValidation;
        result.validations.push(validationError);
        return result;
      }
    } else {
      result.resultType = BusinessResultType.error;
      result.messages.push('validation.iban.notValid');
      const validationError = { businessValidationType: BusinessValidationType.ibanSvs, errorMessage: 'validation.iban.notValid', hasError: true} as BusinessValidation;
      result.validations.push(validationError);
      return result;
    }
  }

  return result;
}

export function isValidBBAN(bbanInput: string): BusinessResult {
  const bban = bbanInput.replace(/-|\.|\s/g, '');

  const validationInProgress: BusinessValidation = {
    businessValidationType: BusinessValidationType.ibanSvs,
    errorMessage: '',
    hasError: false,
  };

  const result: BusinessResult = {
    resultType: BusinessResultType.ok,
    messages: [],
    data: null,
    validations: [validationInProgress],
  };
  const specBE = countrySpecs['BE'];
  if (bban) {
    if (!checkFormatBBAN(bban, specBE)
      || (+bban.slice(0, -2) % 97 !== 0 && +bban.slice(0, -2) % 97 !== +bban.slice(-2))) {
      result.resultType = BusinessResultType.error;
      result.messages.push('validation.bban.notValid');
    }
  }

  return result;
}

export function prepareIbanForModule97(iban: string): string {
  iban = iban.replace('-', '').replace('_', '').replace(' ', '');
  iban = iban.slice(3) + iban.slice(0, 4);
  let validationString = '';
  for (let n = 1; n < iban.length; n++) {
    const c = iban.charCodeAt(n);
    if (c >= 65) {
      validationString += (c - 55).toString();
    } else {
      validationString += iban[n];
    }
  }
  return validationString;
}

function checkFormatBBAN(bban: string, spec: CountrySpec): boolean {
  if (spec.bban_regexp) {
    const reg = new RegExp(spec.bban_regexp, '');
    return reg.test(bban);
  } else {
    return false;
  }
}

function mod9710(validationString: string): number {
  while (validationString.length > 2) {
    const part = validationString.slice(0, 6);
    validationString = (parseInt(part, 10) % 97).toString() + validationString.slice(part.length);
  }
  return parseInt(validationString, 10) % 97;
}

export function isValidBIC(bic: string): boolean {
  const reg = new RegExp('^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$', '');
  const spec = countrySpecs[bic.toUpperCase().slice(4, 6)];
  return reg.test(bic) && spec !== undefined;
}

export function getIBANLength(iban: string): number {
  let result = 0;
  if (iban) {
    result = 2;
    if (iban.length === 1) {
      const reg = new RegExp('^[a-zA-Z]$', '');
      if (!reg.test(iban)) {
        result = 0;
      }
    }
    if (iban.length > 1) {
      const spec = countrySpecs[iban.slice(0, 2).toUpperCase()];
      if (spec && spec.IBANRegistry) {
        result = spec.chars || 0;
      } else {
        result = iban.length;
      }
    }
  }
  return result;
}
